export default __webpack_public_path__ + "static/media/account-number.69facacf.svg";